import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import api from '../Utils/Axios';
import { verifyEmailOtp, resendVerificationOtp } from '../store/userSlice';
import { verifyHospitalEmailOtp, resendHospitalVerificationOtp } from '../store/hospitalSlice';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const token = searchParams.get('token');
  const [email, setEmail] = useState(searchParams.get('email') || '');
  const roleParam = (searchParams.get('role') || 'user').toLowerCase();
  const isHospital = roleParam === 'hospital';
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token || isHospital) return;

    const verifyFromToken = async () => {
      setLoading(true);
      setStatus('idle');
      setMessage('');
      try {
        const response = await api.get(`/api/user/verify-email?token=${token}`);
        setStatus('success');
        setMessage(response.data.message || 'Email verified successfully');
        setTimeout(() => navigate('/login'), 2000);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Email verification failed');
      } finally {
        setLoading(false);
      }
    };

    verifyFromToken();
  }, [token, navigate, isHospital]);

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('idle');
    setMessage('');
    try {
      const action = isHospital ? verifyHospitalEmailOtp : verifyEmailOtp;
      const result = await dispatch(
        action({ email: email.trim(), otp: otp.trim() })
      ).unwrap();
      setStatus('success');
      setMessage(result?.message || 'Email verified successfully');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setStatus('error');
      setMessage(typeof err === 'string' ? err : err?.message || 'OTP verification failed');
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (!email.trim()) {
      setStatus('error');
      setMessage('Please enter your email first');
      return;
    }

    setLoading(true);
    setStatus('idle');
    setMessage('');
    try {
      const action = isHospital ? resendHospitalVerificationOtp : resendVerificationOtp;
      const result = await dispatch(action(email.trim())).unwrap();
      setStatus('success');
      setMessage(result?.message || 'OTP resent successfully');
    } catch (err) {
      setStatus('error');
      setMessage(typeof err === 'string' ? err : err?.message || 'Could not resend OTP');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="verify-email-area pt-120 mb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-xl-5">
            <div className="form-wrapper">
              <div className="form-title text-center">
                <h3>{isHospital ? 'Hospital Email Verification' : 'Email Verification'}</h3>
              </div>

              {token && !isHospital ? (
                <div className="text-center mt-4">
                  {loading && <p>Verifying your email...</p>}
                  {!loading && message && (
                    <div className={`alert ${status === 'success' ? 'alert-success' : 'alert-danger'}`} role="alert">
                      {message}
                    </div>
                  )}
                </div>
              ) : (
                <form onSubmit={handleVerifyOtp} className="mt-4">
                  {message && (
                    <div className={`alert ${status === 'success' ? 'alert-success' : 'alert-danger'}`} role="alert">
                      {message}
                    </div>
                  )}

                  <div className="form-inner mb-3">
                    <label htmlFor="verify-email">Email</label>
                    <input
                      id="verify-email"
                      type="email"
                      placeholder="info@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-inner mb-3">
                    <label htmlFor="verify-otp">OTP</label>
                    <input
                      id="verify-otp"
                      type="text"
                      inputMode="numeric"
                      maxLength={6}
                      placeholder="Enter 6-digit OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      required
                    />
                  </div>

                  <div className="d-grid gap-2">
                    <button className="primry-btn-2 w-100" type="submit" disabled={loading}>
                      {loading ? 'Verifying...' : 'Verify OTP'}
                    </button>
                  </div>

                  <div className="text-center mt-3">
                    <span className="text-muted">Didn&apos;t receive the code? </span>
                    <button
                      type="button"
                      onClick={handleResendOtp}
                      disabled={loading}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#0d6efd',
                        padding: 0,
                        textDecoration: 'underline',
                        cursor: loading ? 'not-allowed' : 'pointer'
                      }}
                    >
                      Resend OTP
                    </button>
                  </div>

                 
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
